import { POST_LOGIN, POST_LOGIN_SUCCESS, RESET_POST_LOGIN_STATE } from "./actionsType"

export const postLoginAction = () => ({
    type: POST_LOGIN,
})
export const postLoginActionSuccess = (payload) => ({
    type: POST_LOGIN_SUCCESS,
    payload
})

export const resetPostLoginActionSuccess = () => ({
    type: RESET_POST_LOGIN_STATE
})